import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import BoltIcon from '@mui/icons-material/Bolt';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import ConstructionOutlinedIcon from '@mui/icons-material/ConstructionOutlined';

const Features = () => {
    const features = [
        {
            icon: <BoltIcon sx={{ fontSize: '24px', color: 'var(--feature-icon-1)' }} />,
            title: 'Instant Results',
            desc: 'Generate RFC 6902 patches in milliseconds. No waiting, no loading screens. Everything happens client-side.',
            bgVar: 'var(--feature-bg-1)'
        },
        {
            icon: <LockOutlinedIcon sx={{ fontSize: '24px', color: 'var(--feature-icon-2)' }} />,
            title: 'Privacy First',
            desc: "Your JSON data never leaves your browser. We don't store or transmit your code.",
            bgVar: 'var(--feature-bg-2)'
        },
        {
            icon: <ConstructionOutlinedIcon sx={{ fontSize: '24px', color: 'var(--feature-icon-3)' }} />,
            title: 'Developer Ready',
            desc: 'Professional code editor features with syntax highlighting, formatting, and shareable URLs.',
            bgVar: 'var(--feature-bg-3)'
        },
    ];

    return (
        <Box sx={{ mt: 'var(--space-12)', mb: 'var(--space-8)', textAlign: 'center' }}>
            <Typography variant="h2" sx={{ fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' }, fontWeight: 700, mb: 2, color: 'var(--fg)' }}>
                Why choose our generator?
            </Typography>
            <Typography variant="body1" sx={{ mb: 5, color: 'var(--fg-muted)' }}>
                Built for speed, privacy, and reliability.
            </Typography>

            <Grid container spacing={3} sx={{ mb: 6 }}>
                {features.map((f) => (
                    <Grid item xs={12} md={4} key={f.title}>
                        <Paper sx={{
                            p: 3, borderRadius: 'var(--radius-lg)', height: '100%',
                            backgroundColor: 'var(--surface)',
                            border: '1px solid var(--border)',
                            boxShadow: 'var(--shadow-xs)',
                            transition: 'box-shadow var(--duration-normal) var(--ease-default), transform var(--duration-fast) var(--ease-default)',
                            '&:hover': { boxShadow: 'var(--shadow-md)', transform: 'translateY(-1px)' },
                            display: 'flex', flexDirection: 'column',
                        }}>
                            <Box sx={{ width: 48, height: 48, backgroundColor: f.bgVar, borderRadius: 'var(--radius-md)', display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
                                {f.icon}
                            </Box>
                            <Typography sx={{ fontSize: 'var(--font-size-lg)', fontWeight: 600, color: 'var(--fg)', mb: 1 }}>{f.title}</Typography>
                            <Typography variant="body2" sx={{ color: 'var(--fg-muted)', lineHeight: 1.6 }}>{f.desc}</Typography>
                        </Paper>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default Features;
